import { Grid } from "@material-ui/core";
import { FunctionComponent } from "react";
import styled from "styled-components";
import { UsersDTO } from "../../../../store/users/models/dto";
import {
    Label,
    LockingDetailCTA,
    ResendEmailVerification, StyledCheckbox,
    StyledWidget
} from "./components";

const StyledLockingDetailCTA = styled(LockingDetailCTA)`
  margin-left: 1em;
`;

const StyledResendEmailVerification = styled(ResendEmailVerification)`
  margin-left: 1em;
`;

export const UserAccountDetails: FunctionComponent<{
  item: UsersDTO.Responses.GetSingle.T;
}> = ({ item }) => {
  const {
    emailAddress,
    userReferenceId,
    userAccountDetails: {
      enabled,
      emailVerified,
      accountNonLocked,
      accountNonExpired,
      credentialsNonExpired,
      loginTries,
    },
    roleDetails,
  } = item;

  return (
    <StyledWidget title={roleDetails.roles.includes("ROLE_MERCHANT") ? "Merchant Account Details" : "User Account Details"}>
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <Label>Enabled</Label>
        </Grid>
        <Grid item xs={3}>
          <StyledCheckbox checked={enabled} disabled />
        </Grid>
        <Grid item xs={3}>
          <Label>Email Verified</Label>
        </Grid>
        <Grid item xs={3}>
          <StyledCheckbox checked={emailVerified} disabled />
          {!emailVerified ? (
            <StyledResendEmailVerification
              email={emailAddress}
              userId={userReferenceId}
            />
          ) : null}
        </Grid>
        <Grid item xs={3}>
          <Label>Account Locked</Label>
        </Grid>
        <Grid item xs={3}>
          <StyledCheckbox checked={!accountNonLocked} disabled />
          <StyledLockingDetailCTA
            type={accountNonLocked ? "lock" : "unlock"}
            userId={userReferenceId}
          />
        </Grid>
        <Grid item xs={3}>
          <Label>Account Expired</Label>
        </Grid>
        <Grid item xs={3}>
          <StyledCheckbox checked={!accountNonExpired} disabled />
        </Grid>
        <Grid item xs={3}>
          <Label>Credentials Expired</Label>
        </Grid>
        <Grid item xs={3}>
          <StyledCheckbox checked={!credentialsNonExpired} disabled />
        </Grid>
        <Grid item xs={3}>
          <Label>Login Tries</Label>
        </Grid>
        <Grid item xs={3}>
          {loginTries}
        </Grid>
      </Grid>
    </StyledWidget>
  );
};
